import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ParkIcon = createIcon({
    viewBox: '0 0 20 20',
    path: (
        <Path
            fillRule='evenodd'
            fill='currentColor'
            d='M17.15 13.138l-6.038-1.966v4.33l1.518 1.19v1.173l-2.639-.775-2.621.775v-1.172l1.482-1.191v-4.33L2.85 13.138v-1.55l6.002-3.951v-4.33c0-.327.109-.605.325-.831.217-.227.489-.34.814-.34.325 0 .594.113.804.34.211.226.317.504.317.831v4.33l6.038 3.951v1.55z'
        />
    ),
})

ParkIcon.displayName = 'ParkIcon'
